import { render, staticRenderFns } from "./GalleryOne.vue?vue&type=template&id=80dcb98c&"
import script from "./GalleryOne.vue?vue&type=script&lang=js&"
export * from "./GalleryOne.vue?vue&type=script&lang=js&"
import style0 from "./GalleryOne.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports